$(function () {
    $('form[id="subForm"]').each(function () {
        var $this = $(this);

        $this.submit(function (e) {
            e.preventDefault();
            var subscriber_name = $('#cm-name').val();

            //Checking if subscriber name contains any numeic value
            var matches = subscriber_name.match(/\d+/g);
            if (matches == null) {
                $.getJSON(
                    this.action + "?callback=?",
                    $(this).serialize(),
                    function (data) {
                        if (data.Status === 400) {
                            if(data.Message === 'This subscribe form requires that you fill in a CAPTCHA to be added to the list.') {
                                console.log('redirecct')
                                var redirectUrl = data.RedirectUrl.replace(':8133', '');
                                window.location.href = redirectUrl;
                            } else {
                                $('div[class="subscribe-msg"]').remove();
                                $(this).append('<div class="subscribe-msg">Success: Your subscription has been confirmed. You\'ve been added to our list and will hear from us soon.</div>');

                            }
                            //$('.subscribe-msg').html("Error: " + data.Message);
                        } else { // 200
                            $('div[class="subscribe-msg"]').remove();
                            $(this).append('<div class="subscribe-msg">'+data.Message+'</div>');
                        }
                    }
                );

                $('div[class="subscribe-msg"]').remove();
                $(this).append('<div class="subscribe-msg">Success: Your subscription has been confirmed. You\'ve been added to our list and will hear from us soon.</div>');
            }

        });
    });
});